import React, { useState } from "react";
import { useLang } from "../context/LanguageContext";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import CareerApplyModal from "../components/CareerApplyModal";
import { MapPin, Briefcase, TrendingUp, Clock, Rocket, HeartHandshake, ArrowRight } from "lucide-react";

export default function Careers() {
  const { t, dir } = useLang();
  const c = t.careers;
  const flip = dir === "rtl" ? "scaleX(-1)" : "none";
  const perkIcons = [TrendingUp, Clock, Rocket, HeartHandshake];
  const [applyFor, setApplyFor] = useState(null);

  return (
    <div>
      <PageHero tag={c.hero.tag} title={c.hero.title} desc={c.hero.desc} />

      <section className="py-12 rq-light">
        <div className="rq-container grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {c.perks.map((p, i) => {
            const Icon = perkIcons[i];
            return (
              <Reveal key={i} delay={i * 100}>
                <div className="rq-card p-7 h-full text-center">
                  <div className="mx-auto grid place-items-center h-14 w-14 rounded-full bg-[rgba(46,230,110,0.12)] text-[color:var(--rq-green)]">
                    <Icon size={26} />
                  </div>
                  <h3 className="font-display mt-5 text-lg font-semibold text-white">{p.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[color:var(--rq-muted)]">{p.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="py-12">
        <div className="rq-container">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-white mb-8">
            {dir === "rtl" ? "الوظائف المتاحة" : "Open Positions"}
          </h2>
          <div className="space-y-4">
            {c.openings.map((o, i) => (
              <Reveal key={i} delay={i * 80}>
                <div className="rq-card p-6 flex flex-col md:flex-row md:items-center justify-between gap-4">
                  <div>
                    <h3 className="font-display text-lg font-semibold text-white">{o.title}</h3>
                    <div className="mt-2 flex flex-wrap gap-4 text-sm text-[color:var(--rq-muted)]">
                      <span className="flex items-center gap-1.5"><Briefcase size={15} />{o.dept}</span>
                      <span className="flex items-center gap-1.5"><MapPin size={15} />{o.location}</span>
                      <span className="flex items-center gap-1.5"><Clock size={15} />{o.type}</span>
                    </div>
                  </div>
                  <button
                    onClick={() => setApplyFor(o.title)}
                    className="rq-glow-btn px-6 py-3 inline-flex items-center gap-2 shrink-0"
                    data-testid={`apply-btn-${i}`}
                  >
                    {c.apply}
                    <ArrowRight size={16} style={{ transform: flip }} />
                  </button>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <CareerApplyModal open={!!applyFor} position={applyFor} onClose={() => setApplyFor(null)} />
    </div>
  );
}
